import { CHANGE_FIELD } from 'app/schema-form/action-types';
import type { ChangeFieldAction } from 'app/schema-form/actions';
import type { FormState } from 'app/schema-form/types';
import { all, takeLatest } from 'redux-saga/effects';
import { createReducer } from 'typesafe-actions';
import type { ImmutableMap } from '../common/utils/immutable-types.js';
import { AI_SET_TOOL_ARG_DEFAULTS, type SetAiToolArgDefaultsAction, setAiToolArgDefaults } from './actions.js';
import { createToolArgsDefaultsSaga } from './saga-utils.js';
import { TOOL_FORM_NAME } from './tool/constants.js';
import type { ToolEditorFormState } from './tool/types.js';

const toolArgsDefaultsSaga = createToolArgsDefaultsSaga(
  TOOL_FORM_NAME,
  setAiToolArgDefaults,
  (action: ChangeFieldAction) => {
    const { path } = action.meta;
    return path[0] === 'execution' && path[1] === 'query' && path[2] === 'ref';
  }
);

export function* aiEditorSaga() {
  yield all([takeLatest(CHANGE_FIELD, toolArgsDefaultsSaga)]);
}

export const handleSetToolArgDefaults = (
  state: ImmutableMap<FormState<ToolEditorFormState>>,
  action: SetAiToolArgDefaultsAction
): ImmutableMap<FormState<ToolEditorFormState>> => {
  return state.setIn(action.meta.path, action.payload.args);
};

export const aiFormReducers = {
  [TOOL_FORM_NAME]: createReducer({} as any, {
    [AI_SET_TOOL_ARG_DEFAULTS]: handleSetToolArgDefaults
  })
};
